<template>
  <ValidationObserver v-slot="{ invalid }">
    <form class="chi-form" @submit.prevent="onSubmit">
      <div class="-mx-3 md:flex">
        <!-- first name -->
        <div class="w-full md:w-1/2 px-3 mb-3">
          <ChiInput
            type="text"
            rules="required|alpha_spaces"
            name="first name"
            label="First Name"
            placeholder="Your First Name"
            v-model="user.firstName"
          />
        </div>

        <!-- last name -->
        <div class="w-full md:w-1/2 px-3 mb-3">
          <ChiInput
            type="text"
            rules="required|alpha_spaces"
            name="last name"
            label="Last Name"
            placeholder="Your Last Name"
            v-model="user.lastName"
          />
        </div>
      </div>

      <div class="-mx-3 md:flex mb-6">
        <!-- email -->
        <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
          <ChiInput
            type="email"
            rules="required|email"
            name="email"
            label="Email"
            placeholder="Your Email"
            v-model="user.email"
          />
        </div>
        <!-- phone -->
        <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
          <ChiInput
            type="tel"
            rules="digits:10"
            name="phone"
            label="Phone"
            placeholder="Your Phone Number"
            v-model="user.phone"
            optional="true"
            maxlength="10"
          />
        </div>
      </div>
      <!-- password -->
      <div class="-mx-3 md:flex mb-6">
        <!-- pass -->

        <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
          <ChiInput
            type="password"
            rules="required|passwordPolicy"
            name="password"
            label="Password"
            placeholder="Create a Password"
            v-model="user.password"
          />
        </div>
        <!-- confirmation -->
        <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
          <ChiInput
            type="password"
            rules="required|passwordCheck:@password"
            name="confirmation"
            label="Password confirmation"
            placeholder="Type your new password"
            v-model="user.confirmPassword"
          />
        </div>
      </div>

      <div class="-mx-3 md:flex mb-6">
        <!-- city -->
        <div class="w-full md:w-1/3 px-3 mb-6 md:mb-0">
          <ChiInput
            type="text"
            rules="required|alpha_spaces"
            name="city"
            label="City"
            placeholder="Your city"
            v-model="user.city"
          />
        </div>
        <!-- state -->
        <div class="w-full md:w-1/3 px-3 mb-6 md:mb-0">
          <ChiInput
            type="select"
            rules="required"
            name="state"
            label="State"
            placeholder="Select your state"
            v-model="user.state"
            :options="states"
          />
        </div>
        <!-- zip -->
        <div class="w-full md:w-1/3 px-3">
          <ChiInput
            type="text"
            rules="required|numeric"
            name="zip"
            label="Zip"
            placeholder="Your zip code"
            v-model="user.zip"
            maxlength="5"
          />
        </div>
      </div>

      <div class="-mx-3 md:flex mb-6">
        <!-- us citizen -->

        <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
          <ChiInput
            type="select"
            rules="required|gc"
            name="citizenship"
            label="Are you a US citizen or a green card holder?"
            placeholder="Please choose"
            v-model="user.citizenOrResident"
            :options="{ true: 'Yes', false: 'No' }"
          />
        </div>

        <!-- no of children -->
        <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
          <ChiInput
            type="number"
            rules="required|min_value:1"
            name="number of children"
            label="How many children would need childcare?"
            placeholder="Number of children"
            v-model="user.hasChildrenOrPlanTo"
            maxlength="2"
            min="1"
          />
        </div>
      </div>

      <div class="-mx-3 mb-2">
        <div class="md:w-full px-3">
          <input
            :disabled="invalid"
            type="submit"
            class="btn btn-purple w-full"
            value="Sign Up"
          />
        </div>
      </div>
      <div class="flex flex-col justify-center items-center pt-5">
        <p class="text-center font-semibold text-sm">
          <router-link :to="{ name: 'Login' }">
            Alredy have an account?
            <br />Login and start viewing our Au Pairs
          </router-link>
        </p>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import { USStates } from "@/helpers.js";
import ChiInput from "@/components/Forms/ChiInput.vue";

export default {
  name: "ApplyForm",
  components: {
    ChiInput,
  },
  data() {
    return {
      states: USStates(),
      user: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        password: "",
        confirmPassword: "",
        city: "",
        state: "",
        zip: "",
        citizenOrResident: null,
        hasChildrenOrPlanTo: "",
      },
    };
  },

  methods: {
    onSubmit() {
      this.$emit("form-submitted", this.user);
    },
  },
};
</script>
